module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "order-section"
  }, [_c('h2', {
    staticClass: "order-section__heading"
  }, [_vm._v("\n            1. An welche PLZ soll geliefert werden?\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postalCode),
      expression: "postalCode"
    }],
    staticClass: "form-control zip-code",
    attrs: {
      "id": "postal-code",
      "name": "postal-code",
      "type": "zipcode",
      "minlength": "4",
      "maxlength": "4",
      "required": ""
    },
    domProps: {
      "value": (_vm.postalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postalCode = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.postalCodeComplete && _vm.isValidPostalCode) ? _c('span', {
    staticClass: "icomoon-check"
  }) : _vm._e()])]), _vm._v(" "), (_vm.showPostalCodeRequiredHint && !_vm.postalCodeComplete) ? _c('p', {
    staticClass: "order-section__required-hint"
  }, [_vm._v("Bitte eine gültige PLZ eingeben.")]) : _vm._e(), _vm._v(" "), (_vm.postalCodeComplete && !_vm.isValidPostalCode) ? _c('p', {
    staticClass: "order-section__description"
  }, [_vm._v("Deine PLZ ist leider noch nicht in unserem Liefergebiet. Du kannst mit der Bestellung trotzdem fortfahren – wir melden uns danach bei dir.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "order-section"
  }, [(_vm.mode === 'private') ? _c('h2', {
    staticClass: "order-section__heading"
  }, [_vm._v("\n            2. Wähle deinen Basis-Korb\n        ")]) : _c('h2', {
    staticClass: "order-section__heading"
  }, [_vm._v("\n            2. Wählt euren Basis-Korb\n        ")]), _vm._v(" "), _c('subscription-types')], 1), _vm._v(" "), _c('div', {
    staticClass: "order-section"
  }, [(_vm.mode === 'private') ? _c('h2', {
    staticClass: "order-section__heading"
  }, [_vm._v("\n            3. Wie gross ist dein Haushalt?\n        ")]) : _c('h2', {
    staticClass: "order-section__heading"
  }, [_vm._v("\n            3. Wie gross ist euer Appetit?\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "order-step-2"
  }, [_c('div', {
    staticClass: "order-step-2__col-container"
  }, [_c('people', {
    attrs: {
      "min": 1,
      "max": _vm.mode === 'private' ? 10 : 50
    }
  }), _vm._v(" "), (_vm.mode === 'business') ? _c('appetite') : _c('appetite-private')], 1), _vm._v(" "), _c('div', {
    staticClass: "order-step-2-variation__details-col-container"
  }, [_c('div', {
    staticClass: "order-step-2-variation__details-col order-step-2-variation__details-col-1"
  }, [(_vm.mode === 'private') ? _c('a', {
    staticClass: "order-step-2-variation__info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleInfoModalVisible("Nach den Empfehlungen der Schweizerischen Gesellschaft für Ernährung sollte eine erwachsene Person täglich 5 Portionen Früchte und Gemüse in verschiedenen Farben zu sich nehmen. Unsere Liefermengen sind so berechnet, dass du täglich mit 1 bis 2 Portionen Früchte oder Gemüse versorgt wirst. Somit deckt der Öpfelchasper 20 bis 40 % deines Bedarfs an Rohkost.")
      }
    }
  }, [_vm._v("\n                        Mengenangaben\n                    ")]) : _vm._e()])])])]), _vm._v(" "), (_vm.mode === 'business') ? _c('results') : _c('results-private')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "postal-code"
    }
  }, [_c('span', {
    staticClass: "label-text"
  }, [_vm._v("\n                    PLZ\n                ")]), _c('span', {
    staticClass: "required-symbol"
  }, [_c('span', {
    staticClass: "sr-only",
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("(Pflichtfeld)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71c5d117","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Order.vue
// module id = 772
// module chunks = 0